import React, { Component, Fragment } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import CreateSingle from './createSingle';
import CreateMultiple from './createMultiple';

export class LotCreate extends Component {
  state = {
    dropdownOpen: false,
    singleIsOpen: false,
    multipleIsOpen: false
  };

  onSingleToggle = () => {
    this.setState({
      singleIsOpen: !this.state.singleIsOpen
    });
  };

  onMultipleToggle = () => {
    this.setState({
      multipleIsOpen: !this.state.multipleIsOpen
    });
  };

  onDropdownToggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };

  render() {
    const { className } = this.props;
    const { singleIsOpen, multipleIsOpen, dropdownOpen } = this.state;

    return (
      <Fragment>
        <ButtonDropdown
          data-qa="lot-schedule-dropdown"
          className={className}
          isOpen={dropdownOpen}
          toggle={this.onDropdownToggle}
        >
          <DropdownToggle color="primary" caret>
            Schedule
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={this.onSingleToggle}>A single lot</DropdownItem>
            <DropdownItem onClick={this.onMultipleToggle}>Multiple lots</DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
        <CreateSingle isOpen={singleIsOpen} onToggle={this.onSingleToggle} />
        <CreateMultiple isOpen={multipleIsOpen} onToggle={this.onMultipleToggle} />
      </Fragment>
    );
  }
}

export default LotCreate;



// WEBPACK FOOTER //
// ./src/containers/lotCreate/lotCreate.jsx